(() => {
  function initialize(root) {
    if (root.dataset.contentReady) return;
    root.dataset.contentReady = 'true';
    const dialog = root.querySelector('[data-size-dialog]');
    const main = root.querySelector('[data-gallery-main]');
    const thumbnails = [...root.querySelectorAll('[data-gallery-src]')];
    const strip = root.querySelector('.lv-gallery-thumbs');
    const photoLabel = root.querySelector('[data-gallery-label]');
    const galleryFrame = root.querySelector('.lv-gallery-main');
    let galleryIndex = Math.max(0, thumbnails.findIndex(button => button.classList.contains('is-active')));
    let colorGalleryOpened = false;
    function showPhoto(index) {
      if (!main || !thumbnails.length) return;
      galleryIndex = (index + thumbnails.length) % thumbnails.length;
      const selected = thumbnails[galleryIndex];
      main.src = selected.dataset.gallerySrc;
      main.alt = selected.dataset.galleryAlt;
      if (photoLabel) photoLabel.textContent = selected.dataset.galleryColor || selected.dataset.galleryTitle || selected.dataset.galleryAlt;
      thumbnails.forEach(button => {
        button.classList.toggle('is-active', button === selected);
        button.setAttribute('aria-pressed', String(button === selected));
      });
      if (strip) {
        if (selected.dataset.galleryColor && !colorGalleryOpened) {
          const firstColor = thumbnails.find(button => button.dataset.galleryColor);
          if (firstColor) strip.scrollLeft += firstColor.getBoundingClientRect().left - strip.getBoundingClientRect().left;
          colorGalleryOpened = true;
        }
        const box = selected.getBoundingClientRect();
        const bounds = strip.getBoundingClientRect();
        if (box.left < bounds.left) strip.scrollLeft -= bounds.left - box.left;
        else if (box.right > bounds.right) strip.scrollLeft += box.right - bounds.right;
      }
    }
    root.addEventListener('lumive:color-change', event => {
      const index = thumbnails.findIndex(button => button.dataset.galleryColor === event.detail?.color);
      if (index >= 0) showPhoto(index);
    });
    galleryFrame?.addEventListener('keydown', event => {
      if (event.target !== galleryFrame || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      showPhoto(galleryIndex + (event.key === 'ArrowRight' ? 1 : -1));
    });
    // Browse photos independently: viewing another color must not change an order selection.
    let touchStart;
    galleryFrame?.addEventListener('touchstart', event => {
      touchStart = event.touches.length === 1 && !event.target.closest('button')
        ? { x: event.touches[0].clientX, y: event.touches[0].clientY } : null;
    }, { passive: true });
    galleryFrame?.addEventListener('touchend', event => {
      if (!touchStart || !event.changedTouches.length) return;
      const dx = event.changedTouches[0].clientX - touchStart.x;
      const dy = event.changedTouches[0].clientY - touchStart.y;
      touchStart = null;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) showPhoto(galleryIndex + (dx < 0 ? 1 : -1));
    }, { passive: true });
    let sizeTrigger;
    root.addEventListener('click', (event) => {
      // A click on the default checked swatch also opens its product photo.
      const color = event.target.closest('[data-tank-color]');
      if (color?.checked && !color.disabled) {
        const index = thumbnails.findIndex(button => button.dataset.galleryColor === color.value);
        if (index >= 0 && (index !== galleryIndex || !colorGalleryOpened)) showPhoto(index);
      }
      const gallery = event.target.closest('[data-gallery-src]');
      if (gallery && root.contains(gallery)) {
        showPhoto(thumbnails.indexOf(gallery));
      }
      if (event.target.closest('[data-gallery-prev]')) showPhoto(galleryIndex - 1);
      if (event.target.closest('[data-gallery-next]')) showPhoto(galleryIndex + 1);
      const trigger = event.target.closest('[data-open-size-guide]');
      if (trigger && dialog) { sizeTrigger = trigger; dialog.showModal(); }
      if (event.target.closest('[data-close-size-guide]')) dialog?.close();
      const play = event.target.closest('[data-play-video]');
      if (play) {
        const video = play.parentElement.querySelector('video');
        video.controls = true;
        play.hidden = true;
        video.play().catch(() => { play.hidden = false; video.controls = true; });
      }
    });
    dialog?.addEventListener('click', event => { if (event.target === dialog) { const box = dialog.getBoundingClientRect(); if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close(); } });
    dialog?.addEventListener('close', () => sizeTrigger?.focus());
    const videos = [...root.querySelectorAll('video')];
    videos.forEach(video => {
      video.addEventListener('play', () => {
        videos.forEach(other => { if (other !== video) other.pause(); });
        const play = video.parentElement.querySelector('[data-play-video]');
        if (play) play.hidden = true;
      });
      video.addEventListener('ended', () => { const play = video.parentElement.querySelector('[data-play-video]'); if (play) play.hidden = false; });
    });
    const sticky = root.querySelector('[data-sticky-cta]');
    const offer = root.querySelector('.lv-offer-section');
    if (sticky && offer && 'IntersectionObserver' in window) {
      let offerVisible = false;
      const updateSticky = () => { sticky.hidden = offerVisible || window.scrollY < 600; };
      const observer = new IntersectionObserver(entries => { offerVisible = entries[0].isIntersecting; updateSticky(); }, {threshold:0});
      observer.observe(offer);
      window.addEventListener('scroll', updateSticky, {passive:true});
      updateSticky();
      root.addEventListener('lumive:cleanup', () => { observer.disconnect(); window.removeEventListener('scroll', updateSticky); }, {once:true});
    }
  }
  const init = () => document.querySelectorAll('lumive-tank-landing').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('lumive-tank-landing').forEach(root => root.dispatchEvent(new Event('lumive:cleanup'))));
})();
